import { styled, Typography, Stack, IconButton, Link as MuiLink } from '@mui/material';
import { Link } from 'react-router-dom';

export const Description = styled(Typography)`
  font-weight: 500;
  font-size: 0.75rem;
  line-height: 1rem;
  color: #a9a9a9;
`;

export const LicenceText = styled(Typography)`
  font-weight: 500;
  font-size: 0.625rem;
  line-height: 0.8125rem;
  color: #efefef;
`;

export const Main = styled(Typography)`
  font-weight: 700;
  font-size: 1.125rem;
  line-height: 1.375rem;
  color: #fefefe;
`;

export const ItemWrapper = styled(Stack)`
  flex-direction: row;
  gap: 8px;
  align-items: center;
`;

export const LinkIconButton = styled(IconButton)`
  padding: 6px 12px;
  border: 1px solid #ededed;
  border-radius: 12px;
  max-width: 35px;
  height: 35px;

  &:hover {
    border-color: #071b3a;
  }

  svg {
    flex-shrink: 0;
  }
`;

export const FooterColumns = styled(Stack)(({ theme }) => ({
  flexDirection: 'column',
  justifyContent: 'space-evenly',
  alignItems: 'flex-start',
  gap: '30px',
  [theme.breakpoints.up('md')]: {
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
}));

export const ItemColumn = styled(Stack)(() => ({
  gap: '30px',
  flex: 1,
}));

export const ActionLink = styled(MuiLink)(() => ({
  fontSize: '16px',
  color: '#6948eb',
  fontWeight: 600,
  textDecoration: 'underline',
}));

export const ContactLink = styled(MuiLink)(({ theme }) => ({
  color: theme.palette.common.black,
  textDecoration: 'none',
  fontWeight: 600,
}));

export const RouterLinkStyled = styled(Link)(({ theme }) => ({
  fontSize: '16px',
  lineHeight: '19px',
  fontWeight: 400,
  color: theme.palette.common.black,
  textDecoration: 'none',
}));

export const ImgStyled = styled('img')(() => ({
  width: '170px',
}));
